import React, { Component } from 'react';
import LogoDocset from '../assets/images/logo_docset.png';

class PageNotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  async componentDidMount() {
    
  }

  render() {
    return (

        <div className="notfound-page">
          <img img src={LogoDocset} />
          <p>Página no encontrada</p>    
        </div>
    );
  }
}

export default PageNotFound;